import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Grid, Tooltip, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getLocationContentByLanguage, hasUsableLocationContent, LOCATION_CONTENT_LANGUAGES } from "./JobLocationContentLanguageEditor";

const FIELDS = [
  ["metaTitle", "Meta Title"],
  ["metaDescription", "Meta Description"],
  ["content", "Page Content"],
];

const STATUS = {
  complete: { label: "Complete", color: "success" },
  partial: { label: "Partial", color: "warning" },
  missing: { label: "Missing", color: "error" },
};

export const getLocationTranslationCoverage = (item = {}) => {
  const content = getLocationContentByLanguage(item);
  return LOCATION_CONTENT_LANGUAGES.map(({ code, name }) => {
    const values = content[code];
    const missing = FIELDS.filter(([field]) => !hasUsableLocationContent(values[field])).map(([, label]) => label);
    const completed = FIELDS.length - missing.length;
    return { code, name, values, missing, completed, status: completed === FIELDS.length ? "complete" : completed ? "partial" : "missing" };
  });
};

export function LocationTranslationCoverageChips({ item = {} }) {
  const coverage = getLocationTranslationCoverage(item);
  const complete = coverage.filter(({ status }) => status === "complete").length;
  return <Box>
    <Box display="flex" flexWrap="wrap" gap={0.4}>
      {coverage.map((language) => <Tooltip key={language.code} title={`${language.name}: ${language.completed}/3 fields complete — missing ${language.missing.join(", ") || "None"}`}>
        <Chip label={language.code.toUpperCase()} color={STATUS[language.status].color} size="small" sx={{ height: 18, fontSize: 9, "& .MuiChip-label": { px: 0.65 } }} />
      </Tooltip>)}
    </Box>
    <Typography variant="caption" color="text.secondary">{complete}/{coverage.length} languages complete</Typography>
  </Box>;
}

export function LocationTranslationCoverageAccordions({ item = {} }) {
  return <Box sx={{ width: "100%", mt: 2 }}>
    <Box display="flex" flexWrap="wrap" gap={2} mb={2}>
      <Typography variant="body2"><strong>Record ID:</strong> {item._id || "Not added"}</Typography>
      <Typography variant="body2"><strong>useAdminMeta:</strong> {item.useAdminMeta === false ? "Disabled" : "Enabled"}</Typography>
    </Box>
    {getLocationTranslationCoverage(item).map((language) => <Accordion key={language.code} disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box display="flex" alignItems="center" gap={1} width="100%">
          <Typography fontWeight={600}>{language.name} ({language.code.toUpperCase()})</Typography>
          <Chip label={`${STATUS[language.status].label} · ${language.completed}/3`} color={STATUS[language.status].color} size="small" />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          {FIELDS.map(([field, label]) => <Grid item xs={12} md={field === "content" ? 12 : 6} key={field}>
            <Typography variant="caption" fontWeight={700}>{label}</Typography>
            {field === "content" && hasUsableLocationContent(language.values[field])
              ? <Box sx={{ color: "text.secondary", mt: 0.5, border: "1px solid", borderColor: "divider", p: 1.25, borderRadius: 1 }} dangerouslySetInnerHTML={{ __html: language.values[field] }} />
              : <Typography color={hasUsableLocationContent(language.values[field]) ? "text.primary" : "text.secondary"}>{hasUsableLocationContent(language.values[field]) ? language.values[field] : "Not added"}</Typography>}
          </Grid>)}
        </Grid>
      </AccordionDetails>
    </Accordion>)}
  </Box>;
}
